import { render, staticRenderFns } from "./stateProfile.vue?vue&type=template&id=35b5c57e"
import script from "./stateProfile.vue?vue&type=script&lang=js"
export * from "./stateProfile.vue?vue&type=script&lang=js"
import style0 from "./stateProfile.vue?vue&type=style&index=0&id=35b5c57e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports